import { Properties, getWrapperWithLogContext, logger } from '@ecosystem/newron-client-lib';

export const logWrapper = getWrapperWithLogContext('client-app');

const ownLogger: typeof logger = {
  info: (message: string, properties?: Properties) => logger.info(message, { ...properties, mfeName: 'client-app' }),
  warning: (message: string, properties?: Properties) =>
    logger.warning(message, { ...properties, mfeName: 'client-app' }),
  error: (errorParam: Error, properties?: Properties) =>
    logger.error(errorParam, { ...properties, mfeName: 'client-app' }),
};

export { ownLogger as logger };
